import { Injectable } from "@angular/core";
import { FormArray, FormControl } from "@angular/forms";
import { DodatniAtributStavkeDto, IAkciznaKategorijaDto, IDodatniAtributStavke, IDodatniAtributStavkeDto, IStavkaOtpremniceDto, JedinicaMere, StavkaOtpremniceDto } from "@kodit/core/data-api";
import { FormBuilderTypeSafe, FormGroupTypeSafe } from "angular-typesafe-reactive-forms-helper";
import { PredmetStavkeFormGroupRequest, PredmetStavkeFormService } from "../../../../../form-definitions/src/lib/predmet-stavke/predmet-stavke-form.service";
import { JedinicaMereFormService } from "../../../../../form-definitions/src/lib/jedinica-mere/jedinica-mere-form.service";
import { OznakaFormService } from "../../../../../form-definitions/src/lib/common/oznaka-form.service";

@Injectable({
  providedIn: 'root',
})

export class StavkaEoptremniceFormService {

  constructor(
    private _fb: FormBuilderTypeSafe,
    private _predmetStavkeFS: PredmetStavkeFormService,
    private _jedinicaMereFS: JedinicaMereFormService,
    private _oznakeFS: OznakaFormService
  ) {}

  public GetFormArray(models?: StavkaOtpremniceDto[]): FormArray {
    return this._fb.array(models?.map(m => this.getFormGroup(m)) ?? []);
  }

  public getFormGroup(model?: IStavkaOtpremniceDto): FormGroupTypeSafe<IStavkaOtpremniceDto> {
    return this._fb.group<IStavkaOtpremniceDto>({
      id: new FormControl(model?.id),
      gtin: new FormControl(model?.gtin),
      naziv: new FormControl(model?.naziv),
      kolicina: new FormControl(model?.kolicina ?? 1),
      jedinicaMereDto: this._jedinicaMereFS.GetJedinicuMereFormGroup(model?.jedinicaMereDto),
      akciznaKategorijaDto: this.getAkciznaKategorijaFormGroup(model?.akciznaKategorijaDto),
      komentar: new FormControl(model?.komentar),
      pristiglaKolicina: new FormControl(model?.pristiglaKolicina),
      primljenaKolicina: new FormControl(model?.primljenaKolicina),
      vracenaKolicina: new FormControl(model?.vracenaKolicina),
      dodatniAtributiDto: this.getDodatniAtributiFormArray(model?.dodatniAtributiDto),
      predmetStavkeDto: this._predmetStavkeFS.GetPredmetStavkeFormGroup(
        new PredmetStavkeFormGroupRequest({
          model: model?.predmetStavkeDto,
          isCenaRequired: false,
          isJedinicaMereRequired: false,
        })
      ),
      redniBroj : new FormControl(model?.redniBroj),
      sifra: new FormControl(model?.sifra)
    });
  }

  public getAkciznaKategorijaFormGroup(model?: IAkciznaKategorijaDto): FormGroupTypeSafe<IAkciznaKategorijaDto>
  {
    return this._fb.group<IAkciznaKategorijaDto>({
      tipAkcizneKategorije: new FormControl(model?.tipAkcizneKategorije),
      vrednost: new FormControl(model?.vrednost),
      tipPakovanjaDuvana: new FormControl(model?.tipPakovanjaDuvana),
      sifraRobneMarke: new FormControl(model?.sifraRobneMarke)
    });
  }

  public getDodatniAtributiFormArray(models?: DodatniAtributStavkeDto[]): FormArray {
    return this._fb.array(models?.map(m => this.getDodatniAtributFormGroup(m)) ?? []);
  }

  public getDodatniAtributFormGroup(model?: IDodatniAtributStavkeDto): FormGroupTypeSafe<IDodatniAtributStavkeDto>
  {
    return this._fb.group<IDodatniAtributStavkeDto>({
      id: new FormControl(model?.id),
      naziv: new FormControl(model?.naziv),
      vrednost: new FormControl(model?.vrednost)
    });
  }
}
